export interface MarginParams {
  overAllowanceSplit?: number
  price: number
  sellPrice: number
}

export function calculateMarginNumber(params: MarginParams): number {
  const overAllowanceSplit = params.overAllowanceSplit ?? 0

  const marginNumber = params.sellPrice - overAllowanceSplit - params.price

  return marginNumber
}
